import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { WorkCenterAssignmentStrategy } from './work-center'

@Directive({
  selector: '[appAssignmentStrategySelect]',
})
export class AssignmentStrategySelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'shopfloor.workcenters.assignmentStrategies.assignmentStrategy'
    this.select.displayProperty = 'displayValue'

    this.select.dataSource = enumTranslationService.enumDataSource(
      WorkCenterAssignmentStrategy,
      'shopfloor.workcenters.assignmentStrategies',
      false
    )
  }
}
